<template>
  <div v-if="permissions.includes('summary_report.read')">
    <div>
      <div class="border-0 mt-4 mx-3">
        <div
          class="d-flex border-bottom flex-md-row flex-column gap-2 justify-content-md-between justify-content-center align-items-center"
          :class="currentUser.user_role == 1 ? '' : 'pb-3'"
        >
          <div class="">
            <h3 class="text-dark text-md-start text-center">Summary</h3>
            <ul
              class="nav text-center d-flex justify-content-md-start justify-content-center align-item-center"
              v-if="permissions.includes('summary_report.team_view')"
            >
              <li
                class="nav-item p-0 me-2"
                @click="pageChanger('your_summary')"
                :style="yourStyle"
              >
                <a
                  class="nav-link px-0 py-2 fs-6"
                  style="color: inherit; cursor: pointer; white-space: nowrap"
                  >Your Summary</a
                >
              </li>

              <li
                class="nav-item p-0"
                style="cursor: pointer"
                :style="teamStyle"
                @click="pageChanger('team_summary')"
              >
                <a class="nav-link px-0 py-2 fs-6" style="color: inherit; white-space: nowrap"
                  >Team's Summary</a
                >
              </li>
            </ul>
            <ol v-else class="breadcrumb m-0">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'DashboardContent' }" tag="a">
                  Dashboard
                </router-link>
              </li>
              <li class="breadcrumb-item active">Summary</li>
            </ol>
          </div>
          <button
            v-if="current_page == 'your_summary'"
            class="btn btn-primary btn-sm my-md-0 my-3"
            @click="reportSummaryModalHandler"
          >
            Add Summary
          </button>
        </div>
        <div class="bg-white p-4 shadow-sm rounded-bottom mb-4">
          <transition name="slide-fade" mode="out-in">
            <div v-if="current_page == 'your_summary'" key="your_summary">
              <div
                class="d-flex flex-wrap justify-content-md-start justify-content-center align-items-center gap-2"
              >
                <div style="min-width: 200px">
                  <multiselect
                    :options="project_list"
                    v-model="your_filter_obj.selected_project"
                    label="project_name"
                    track-by="id"
                    placeholder="Select Project(s)"
                    :multiple="true"
                    @input="getYourSummaryReports"
                  ></multiselect>
                </div>
                <datepicker
                  :minimumView="'month'"
                  :maximumView="'year'"
                  :disabledDates="disableDateConfig"
                  v-model="your_filter_obj.selected_date"
                  :format="'yyyy-MM'"
                  :calendar-button="true"
                  :input-class="'border-start-0'"
                  :calendar-button-icon="'fa fa-calendar'"
                  :bootstrap-styling="true"
                  @selected="getYourSummaryReports"
                />
              </div>
              <div class="mt-3">
                <vue-good-table
                  mode="remote"
                  @on-page-change="onYourSummaryReportPageChange"
                  @on-sort-change="onYourSummaryReportSortChange"
                  @on-column-filter="onYourSummaryReportColumnFilter"
                  @on-per-page-change="onYourSummaryReportPerPageChange"
                  :totalRows="your_filter_obj.totalRecords"
                  :isLoading.sync="your_filter_obj.isLoading"
                  :pagination-options="{
                    enabled: true,
                  }"
                  :rows="your_filter_obj.rows"
                  :columns="your_filter_obj.columns"
                  styleClass="vgt-table "
                >
                  <template slot="table-row" slot-scope="props">
                    <div v-if="props.column.field == 'action'">
                      <div
                        class="d-flex justify-content-center align-items-center gap-3"
                      >
                        <button
                          class="btn-pencil bg-transparent"
                          @click="reportSummaryModalHandler($event, props.row)"
                        >
                          <i class="fa fa-pencil fs-5"></i>
                        </button>
                        <button
                          class="btn-trash bg-transparent"
                          @click="deleteSummaryReport(props.row.id)"
                        >
                          <i class="fa fa-trash fs-5"></i>
                        </button>
                      </div>
                    </div>
                    <div v-else-if="props.column.field == 'summary'">
                      <readMore
                        more-str="read more"
                        :text="props.row.summary"
                        less-str="read less"
                        :max-chars="100"
                      >
                      </readMore>
                    </div>
                    <!-- <div v-else-if="props.column.field == 'date_range_label'">
                    <h6>
                      <span
                        class="badge badge-light border mt-1"
                        v-text="props.row.date_range_label"
                      ></span>
                    </h6>
                  </div> -->
                  </template>
                  <template slot="pagination-bottom" slot-scope="props">
                    <div class="p-2">
                      <CustomPagination
                        :pageTabs="4"
                        :total="props.total"
                        :pageChanged="props.pageChanged"
                        :perPageChanged="props.perPageChanged"
                        :serverParams="your_filter_obj.serverParams"
                      />
                    </div>
                  </template>
                </vue-good-table>
              </div>
            </div>

            <div v-else>
              <redmineFilter
                ref="redmineFilter"
                page="summary_team"
                @redmine-filter-data="redmineFilterHandler"
                @reset-server-params="onResetServerParams"
                :serverParams="serverParams"
              ></redmineFilter>
              <div class="d-flex gap-2 mt-3 mb-3">
                <button 
                  class="btn btn-sm btn-primary"
                  @click="exportTeamSummary('excel')"
                  :disabled="team_filter_obj.isLoading"
                >
                  <i class="fa fa-file-excel-o"></i> Export Excel
                </button>
                <button 
                  class="btn btn-sm btn-primary"
                  @click="exportTeamSummary('pdf')"
                  :disabled="team_filter_obj.isLoading"
                >
                  <i class="fa fa-file-pdf-o"></i> Export PDF
                </button>
              </div>
              <div class="mt-3">
                <!-- <div v-if="not_filled_details.length > 0" class="alert alert-warning alert-dismissible fade show mb-3" role="alert">
                  <h6 class="alert-heading mb-3"><strong>⚠️ Not Filled Summaries</strong></h6>
                  <div class="not-filled-users-container">
                    <div v-for="user in not_filled_details" :key="user.user_id" class="mb-3 pb-2" style="border-bottom: 1px solid rgba(255, 193, 7, 0.2)">
                      <div class="mb-1">
                        <strong class="text-dark">{{ user.user_name }}</strong>
                        <span class="badge badge-light ms-2">{{ getUserProjectCount(user) }} projects pending</span>
                      </div>
                      <div class="ms-3 mt-2">
                        <small class="text-muted">
                          {{ user.projects }}
                        </small>
                      </div>
                    </div>
                  </div>
                  <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div> -->
                <vue-good-table
                  mode="remote"
                  @on-page-change="onTeamSummaryReportPageChange"
                  @on-sort-change="onTeamSummaryReportSortChange"
                  @on-column-filter="onTeamSummaryReportColumnFilter"
                  @on-per-page-change="onTeamSummaryReportPerPageChange"
                  :totalRows="team_filter_obj.totalRecords"
                  :isLoading.sync="team_filter_obj.isLoading"
                  :pagination-options="{
                    enabled: true,
                  }"
                  :rows="team_filter_obj.rows"
                  :columns="team_filter_obj.columns"
                  styleClass="vgt-table "
                >
                  <template slot="table-row" slot-scope="props">
                    <div v-if="props.column.field == 'summary'">
                      <readMore
                        more-str="read more"
                        :text="props.row.summary"
                        less-str="read less"
                        :max-chars="100"
                      >
                      </readMore>
                    </div>
                    <!-- <div v-if="props.column.field == 'action'">
                  <div
                    class="d-flex justify-content-center align-items-center gap-3"
                  >
                    <button class="btn-pencil">
                      <i class="fa fa-pencil fs-5"></i>
                    </button>
                    <button class="btn-trash">
                      <i class="fa fa-trash fs-5"></i>
                    </button>
                  </div>
                </div> -->
                  </template>
                  <template slot="pagination-bottom" slot-scope="props">
                    <div class="p-2">
                      <CustomPagination
                        :pageTabs="4"
                        :total="props.total"
                        :pageChanged="props.pageChanged"
                        :perPageChanged="props.perPageChanged"
                        :serverParams="team_filter_obj.serverParams"
                      />
                    </div>
                  </template>
                </vue-good-table>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <!-- Add summary model -->
      <div
        class="modal fade"
        id="summaryReportModal"
        role="dialog"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-hidden="true"
        tabindex="-1"
      >
        <div
          class="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div class="modal-content">
            <div class="modal-header">
              <h3
                class="text-dark font-weight-bold m-0"
                id="taskModalLongTitle"
                v-text="title"
              ></h3>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-12">
                  <small class="form-label mandatory">Select Project</small>
                  <multiselect
                    :options="project_list"
                    v-model="popupObj.selected_project"
                    label="project_name"
                    track-by="id"
                    placeholder="Select Project"
                    class="mt-1"
                  ></multiselect>
                  <small
                    class="text-danger"
                    v-if="popupObj.validation.project"
                    v-text="popupObj.validation.project"
                  ></small>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-6">
                  <small class="mandatory">Select Month</small>
                  <div class="pt-1"></div>
                  <datepicker
                    :minimumView="'month'"
                    :maximumView="'year'"
                    :disabledDates="disableDateConfig"
                    v-model="popupObj.selected_month"
                    :format="'yyyy-MM'"
                    :calendar-button="true"
                    :input-class="'border-start-0 col-12'"
                    :calendar-button-icon="'fa fa-calendar'"
                    :bootstrap-styling="true"
                    @selected="generateYourMonthOptions"
                  />
                  <small
                    class="text-danger"
                    v-if="popupObj.validation.month"
                    v-text="popupObj.validation.month"
                  ></small>
                </div>
                <div class="col-6">
                  <small class="">Select Week</small>
                  <multiselect
                    :options="popupObj.month_week_options"
                    v-model="popupObj.selected_month_week_options"
                    label="label"
                    class="mt-1"
                  ></multiselect>
                  <small class="form-text text-muted d-block mt-1">
                    <i class="fa fa-info-circle"></i> Note: To fill monthly summary, do not select week.
                  </small>
                </div>
              </div>

              <div class="mt-3">
                <div class="d-flex flex-column">
                  <small class="form-label mandatory"
                    >Description/Summary</small
                  >
                  <textarea
                    class="form-control"
                    rows="5"
                    placeholder="Enter the description/summary here..."
                    v-model="popupObj.summary"
                    @input="formatSummary"
                  ></textarea>
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <small
                      class="text-danger"
                      v-if="popupObj.validation.summary"
                      v-text="popupObj.validation.summary"
                    ></small>
                    <small class="ms-auto text-secondary mt-1">{{
                      summaryWordCount
                    }}</small>
                  </div>
                </div>
              </div>
              <div
                class="d-flex justify-content-end align-items-center gap-2 mt-3"
              >
                <div class="btn btn-primary btn-sm" @click="submitBtnHandler">
                  Submit
                </div>
                <div
                  class="btn btn-outline-secondary btn-sm"
                  data-bs-dismiss="modal"
                >
                  Close
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <UnauthorizedPage />
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { mapState, mapActions } from "vuex";
import moment from "moment";
import DatePicker from "vuejs-datepicker";
import user from "@/ajax/user";
import UnauthorizedPage from "@/views/Layouts/UnauthorizedPage.vue";
import CustomPagination from "../../components/CustomPagination.vue";
import redmineFilter from "../../components/redmine_filter.vue";
import ReadMore from "vue-read-more";
import Vue from "vue";

Vue.use(ReadMore);

export default {
  components: {
    Multiselect,
    datepicker: DatePicker,
    UnauthorizedPage,
    CustomPagination,
    redmineFilter,
  },
  data() {
    return {
      title: "Add Summary",
      current_page: "your_summary",
      months_options: [],
      month_week_options: [],
      master_user_list: [],
      user_list: [],
      not_filled_details: [],
      project_list: [],
      disableDateConfig: {
        to: moment("2024-04-01").toDate(),
        from: moment().toDate(),
      },
      popupObj: {
        month_week_options: [],
        selected_month: null,
        selected_month_week_options: null,
        selected_project: null,
        summary: null,
        charLimit: 5000,
        validation: {
          summary: null,
          month: null,
          project: null,
        },
      },
      team_filter_obj: {
        selected_date: new Date(),
        month_options: [],
        selected_month_options: null,
        selected_project: null,
        users: [],
        totalRecords: 0,
        isLoading: true,
        view_options: [
          {
            label: "Month/Week Both",
            value: "both_month_and_week",
          },
          {
            label: "Month Only",
            value: "month_only",
          },
          {
            label: "Week Only",
            value: "week_only",
          },
        ],
        selected_view_options: null,
        serverParams: {
          filters: {},
          sort: [],
          page: 1,
          perpage: 100,
        },
        columns: [
          {
            field: "date_range_label",
            label: "Date Range",
            width: "20rem",
            thClass: "custom-th",
            tdClass: "custom-td",
          },
          {
            field: "project_name",
            label: "Project",
            width: "15rem",
            thClass: "custom-th",
            tdClass: "custom-td",
          },
          {
            field: "full_name",
            label: "User",
            width: "22rem",
            thClass: "custom-th",
            tdClass: "custom-td",
          },
          {
            field: "summary",
            label: "Summary",
            width: "20rem",
            thClass: "custom-th",
            tdClass: "custom-td",
          },
        ],
        rows: [],
      },
      your_filter_obj: {
        selected_date: new Date(),
        selected_project: null,
        totalRecords: 0,
        isLoading: true,
        serverParams: {
          filters: {},
          sort: [],
          page: 1,
          perpage: 100,
        },
        columns: [
          {
            field: "project_name",
            label: "Project",
            width: "15rem",
            thClass: "custom-th",
            tdClass: "custom-td",
          },
          {
            field: "date_range_label",
            label: "Date Range",
            width: "20rem",
            thClass: "custom-th",
            tdClass: "custom-td",
          },
          {
            field: "summary",
            label: "Summary",
            width: "20rem",
            thClass: "custom-th",
            tdClass: "custom-td",
          },
          {
            field: "action",
            label: "Action",
            width: "12rem",
            thClass: "custom-th",
            tdClass: "custom-td",
          },
        ],
        rows: [],
      },
      permissions: localStorage.getItem("permissions"),
      siteLogReq: {
        site_name: "summary_report",
      },
      serverParams: {
        filters: {},
        sort: [],
        page: 1,
        perpage: 100,
      },
    };
  },
  computed: {
    ...mapState("userStore", ["currentUser"]),
    summaryWordCount() {
      if (this.popupObj.summary != null) {
        return `${this.popupObj.summary.length}/${this.popupObj.charLimit}`;
      }
      return `0/${this.popupObj.charLimit}`;
    },
    yourStyle() {
      if (this.current_page == "your_summary") {
        return {
          color: "#583D72",
          "border-bottom": "3px solid #583D72",
        };
      } else {
        return { color: "#79869F", "border-bottom": "" };
      }
    },
    teamStyle() {
      if (this.current_page == "team_summary") {
        return {
          color: "#583D72",
          "border-bottom": "3px solid #583D72",
        };
      } else {
        return { color: "#79869F", "border-bottom": "" };
      }
    },
  },
  created() {
    user.createSiteUsage(this.siteLogReq);
  },
  mounted() {
    this.setCurrentPage("Summary");
    moment.locale("en");
    this.getYourSummaryReports();
    this.getUsers();
    this.getProjects();
    $("#summaryReportModal").on("hidden.bs.modal", this.hideModalEventHandler);
  },
  methods: {
    ...mapActions("common", ["setCurrentPage"]),
    formatSummary() {
      if (this.popupObj.summary.length > this.popupObj.charLimit) {
        this.popupObj.summary = this.popupObj.summary.slice(
          0,
          this.popupObj.charLimit
        );
      }
    },
    onYourSummaryReportPageChange(params) {
      this.onYourSummaryReportUpdateParams({ page: params.currentPage });
      this.getYourSummaryReports();
    },

    onYourSummaryReportPerPageChange(params) {
      this.your_filter_obj.serverParams.page = 1;
      this.onYourSummaryReportUpdateParams({ perpage: params.currentPerPage });
      this.getYourSummaryReports();
    },
    onYourSummaryReportColumnFilter(params) {
      this.onYourSummaryReportUpdateParams(params);
      this.getYourSummaryReports();
    },
    onYourSummaryReportUpdateParams(newProps) {
      this.your_filter_obj.serverParams = Object.assign(
        {},
        this.your_filter_obj.serverParams,
        newProps
      );
    },
    onYourSummaryReportSortChange(params) {
      this.onYourSummaryReportUpdateParams({
        sort: [
          {
            type: params[0].type,
            field: params[0].field,
          },
        ],
      });
      this.getYourSummaryReports();
    },

    onTeamSummaryReportPageChange(params) {
      this.onTeamSummaryReportUpdateParams({ page: params.currentPage });
      this.getTeamSummaryReports();
    },

    onTeamSummaryReportPerPageChange(params) {
      this.onTeamSummaryReportUpdateParams({ perpage: params.currentPerPage });
      this.team_filter_obj.serverParams.page = 1;
      this.getTeamSummaryReports();
    },
    onTeamSummaryReportColumnFilter(params) {
      this.onTeamSummaryReportUpdateParams(params);
      this.getTeamSummaryReports();
    },
    onTeamSummaryReportUpdateParams(newProps) {
      this.team_filter_obj.serverParams = Object.assign(
        {},
        this.team_filter_obj.serverParams,
        newProps
      );
    },
    onTeamSummaryReportSortChange(params) {
      this.onTeamSummaryReportUpdateParams({
        sort: [
          {
            type: params[0].type,
            field: params[0].field,
          },
        ],
      });
      this.getTeamSummaryReports();
    },

    hideModalEventHandler() {
      this.popupObj.selected_month = new Date();
      this.popupObj.selected_month_week_options = null;
      this.popupObj.selected_project = null;
      this.popupObj.summary = null;
      this.popupObj.validation.summary = null;
      this.popupObj.validation.month = null;
      if (Object.keys(this.popupObj).includes("id")) {
        delete this.popupObj.id;
      }
      this.generateYourMonthOptions(this.popupObj.selected_month);
    },
    getUsers() {
      user.getUsers().then((result) => {
        this.master_user_list = [
          { label: "Select all", users_data: result.data.data },
        ];
        this.getFilteredUsers();
      });
    },
    getFilteredUsers() {
      let end_of_month = moment(this.team_filter_obj.selected_date)
        .endOf("month")
        .format("YYYY-MM-DD");
      let end_date = moment(end_of_month);
      let filtered_user_list = this.master_user_list[0].users_data.filter(
        (item) => {
          return (
            item.id != this.currentUser.id &&
            (item.doe == null ||
              (item.doe != null &&
                moment(item.doe, "YYYY-MM-DD").isSameOrAfter(end_date)))
          );
        }
      );
      this.team_filter_obj.users = this.team_filter_obj.users.filter((item) => {
        return (
          item.id != this.currentUser.id &&
          (item.doe == null ||
            item.doe == null ||
            (item.doe != null &&
              moment(item.doe, "YYYY-MM-DD").isSameOrAfter(end_date)))
        );
      });
      this.user_list = structuredClone(this.master_user_list);
      this.user_list[0].users_data = filtered_user_list;
    },
    getProjects() {
      user.getAllProjects().then((result) => {
        if (result.data && result.data.data) {
          this.project_list = result.data.data;
        }
      }).catch((err) => {
        console.error("Error fetching projects:", err);
      });
    },
    getYourSummaryReports(val) {
      if (val != null && val instanceof Date) {
        this.your_filter_obj.selected_date = new Date(val);
      }
      let from_date = moment(this.your_filter_obj.selected_date)
        .startOf("month")
        .format("YYYY-MM-DD");
      let to_date = moment(this.your_filter_obj.selected_date)
        .endOf("month")
        .format("YYYY-MM-DD");
      
      // Handle multiple projects
      let project_ids = [];
      if (this.your_filter_obj.selected_project) {
        if (Array.isArray(this.your_filter_obj.selected_project)) {
          project_ids = this.your_filter_obj.selected_project.map(p => p.id);
        } else {
          project_ids = [this.your_filter_obj.selected_project.id];
        }
      }
      
      const reqObj = {
        from_date: from_date,
        for_month: from_date,
        to_date: to_date,
        project_ids: project_ids,
      };
      let serverParams = Object.assign(this.your_filter_obj.serverParams, {
        filters: reqObj,
      });
      this.your_filter_obj.isLoading = true;
      this.your_filter_obj.rows.length = 0;
      this.your_filter_obj.totalRecords = 0;
      user
        .get_your_summary_reports(serverParams)
        .then((res) => {
          this.your_filter_obj.rows = res.data.data.data;
          this.your_filter_obj.totalRecords = res.data.data.total;
          this.your_filter_obj.isLoading = false;
        })
        .catch((err) => (this.your_filter_obj.isLoading = false));
    },
    buildTeamFilterRequest() {
      let from_date = moment(this.team_filter_obj.selected_date)
        .startOf("month")
        .format("YYYY-MM-DD");
      let to_date = moment(this.team_filter_obj.selected_date)
        .endOf("month")
        .format("YYYY-MM-DD");

      // Handle multiple projects
      let project_ids = [];
      if (this.team_filter_obj.selected_project) {
        if (Array.isArray(this.team_filter_obj.selected_project)) {
          project_ids = this.team_filter_obj.selected_project.map(p => p.id);
        } else {
          project_ids = [this.team_filter_obj.selected_project.id];
        }
      }

      const reqObj = {
        from_date: from_date,
        to_date: to_date,
        for_month: from_date,
        users: this.team_filter_obj.users.map((e) => e.id),
        view_type: this.team_filter_obj.selected_view_options.value,
        project_ids: project_ids,
      };
      
      // Only include project_ids if there are any selected
      if (project_ids.length === 0) {
        delete reqObj.project_ids;
      }
      
      // Only include users if there are any selected
      if (reqObj.users.length === 0) {
        delete reqObj.users;
      }
      
      if (this.team_filter_obj.selected_month_options != null) {
        reqObj.from_date = this.team_filter_obj.selected_month_options.from_date;
        reqObj.to_date = this.team_filter_obj.selected_month_options.to_date;
      }

      return reqObj;
    },
    getTeamSummaryReports() {
      // Use serverParams directly from redmine filter
      this.team_filter_obj.isLoading = true;
      this.team_filter_obj.rows.length = 0;
      this.team_filter_obj.totalRecords = 0;
      user
        .get_team_summary_reports(this.team_filter_obj.serverParams)
        .then((res) => {
          this.team_filter_obj.rows = res.data.data.data;
          this.team_filter_obj.totalRecords = res.data.data.total;
          this.team_filter_obj.isLoading = false;
        // this.getTeamNotFilledDetails();
        })
        .catch((err) => {
          this.team_filter_obj.isLoading = false;
        });
    },
    getTeamNotFilledDetails() {
      const reqObj = this.buildTeamFilterRequest();
      let serverParams = Object.assign(this.team_filter_obj.serverParams, {
        filters: reqObj,
      });
      user
        .get_team_not_filled_details(serverParams)
        .then((res) => {
          // API returns data directly in res.data.data array
          this.not_filled_details = res.data.data || [];
          console.log("Not filled details:", this.not_filled_details);
        })
        .catch((err) => {
          console.error("Error fetching not filled details:", err);
          this.not_filled_details = [];
        });
    },
    validator() {
      let isValid = true;
      if (this.popupObj.selected_month == null) {
        this.popupObj.validation.month = "Please select the month";
        isValid = false;
        return isValid;
      } else {
        this.popupObj.validation.month = null;
      }

      if (this.popupObj.selected_project == null) {
        this.popupObj.validation.project = "Please select a project";
        isValid = false;
        return isValid;
      } else {
        this.popupObj.validation.project = null;
      }

      if (this.popupObj.summary == null || this.popupObj.summary == "") {
        this.popupObj.validation.summary = "Please enter the summary";
        isValid = false;
        return isValid;
      } else {
        this.popupObj.validation.summary = null;
      }
      return isValid;
    },
    submitBtnHandler() {
      if (this.validator()) {
        let firstDate = moment(this.popupObj.selected_month)
          .startOf("month")
          .format("YYYY-MM-DD");
        let lastDate = moment(this.popupObj.selected_month)
          .endOf("month")
          .format("YYYY-MM-DD");
        const reqObj = {
          from_date: firstDate,
          to_date: lastDate,
          for_month: firstDate,
          summary: this.popupObj.summary.trim(),
          project_id: this.popupObj.selected_project.id,
        };
        if (this.popupObj.selected_month_week_options != null) {
          reqObj.from_date =
            this.popupObj.selected_month_week_options.from_date;
          reqObj.to_date = this.popupObj.selected_month_week_options.to_date;
        }
        if (Object.keys(this.popupObj).includes("id")) {
          user
            .update_summary_report(this.popupObj.id, reqObj)
            .then((res) => {
              if (res.status == 200) {
                Swal.fire({
                  title: "Summary Updated Successfully",
                  icon: "success",
                });
                this.getYourSummaryReports();
              } else {
                Swal.fire({
                  title: "Failed To Update Summary",
                  icon: "error",
                });
              }
            })
            .catch((err) => {
              console.error(err);
              let error_msg = err.response
                ? err.response.data.detail
                : "Something Went Wrong";
              Swal.fire({
                title: error_msg,
                icon: "error",
              });
            });
        } else {
          user
            .add_summary_report(reqObj)
            .then((res) => {
              if (res.status == 200) {
                Swal.fire({
                  title: "Summary Added Successfully",
                  icon: "success",
                });
                this.getYourSummaryReports();
              } else {
                Swal.fire({
                  title: "Failed To Add Summary",
                  icon: "error",
                });
              }
            })
            .catch((err) => {
              console.error(err);
              let error_msg = err.response
                ? err.response.data.detail
                : "Something Went Wrong";
              Swal.fire({
                title: error_msg,
                icon: "error",
              });
            });
        }

        $("#summaryReportModal").modal("hide");
      }
    },
    generateDropdownOptions() {
      const baseDate = new Date();

      const createOption = (date) => {
        const label = moment(date).format("MMMM YYYY");
        const fromDate = moment(date).startOf("month").format("YYYY-MM-DD");
        const toDate = moment(date).endOf("month").format("YYYY-MM-DD");

        return {
          label: label,
          from_date: fromDate,
          to_date: toDate,
        };
      };

      const currentMonth = createOption(baseDate);
      const lastMonth = createOption(moment(baseDate).subtract(1, "months"));
      const twoMonthsAgo = createOption(moment(baseDate).subtract(2, "months"));

      this.popupObj.month_options = [currentMonth, lastMonth, twoMonthsAgo];
      this.popupObj.selected_month = baseDate;
      this.popupObj.month_week_options = this.getWeeksOfMonth(
        baseDate.getFullYear(),
        baseDate.getMonth() + 1
      );
    },
    getWeeksOfMonth(year, month) {
      const baseDate = moment().toDate();
      baseDate.setFullYear(year);
      baseDate.setMonth(month - 1);
      baseDate.setDate(1);
      const firstDateOfMonth = moment(baseDate, "YYYY-MM-DD").startOf("month");
      const firstDateOfWeek = firstDateOfMonth.clone().startOf("isoWeek");
      const noOfWeeks = 5;
      const dates = [];
      let monday = firstDateOfWeek.clone();
      for (let i = 0; i < noOfWeeks; i++) {
        let sunday = monday.clone().endOf("isoWeek");
        dates.push({
          label: `${monday.format("Do MMM")} to ${sunday.format(
            "Do MMM"
          )} (Week ${i + 1}) `,
          from_date: monday.format("YYYY-MM-DD"),
          to_date: sunday.format("YYYY-MM-DD"),
        });
        monday = monday.clone().add(1, "week");
      }
      return dates;
    },
    reportSummaryModalHandler(e, summaryReport) {
      this.popupObj.selected_month = moment().toDate();
      if (summaryReport != null) {
        this.popupObj.id = summaryReport.id;
        this.popupObj.summary = summaryReport.summary;
        this.popupObj.selected_month = summaryReport.for_month;
        this.popupObj.selected_project = this.project_list.find(
          (p) => p.id === summaryReport.project_id
        );
        this.generateYourMonthOptions(
          moment(this.popupObj.selected_month).toDate()
        );
        this.popupObj.selected_month_week_options =
          this.popupObj.month_week_options.find((e) => {
            return (
              e.from_date == summaryReport.from_date &&
              e.to_date == summaryReport.to_date
            );
          });
        this.title = "Update Report Summary";
      } else {
        this.generateYourMonthOptions(this.popupObj.selected_month);
      }
      $("#summaryReportModal").modal("show");
    },
    custom_label(name) {
      if (name.last_name != null && name.middle_name != null) {
        return `${name.first_name} ${name.middle_name} ${name.last_name}`;
      } else if (name.last_name == null) {
        return `${name.first_name} ${name.middle_name}`;
      } else if (name.middle_name == null) {
        return `${name.first_name} ${name.last_name}`;
      }
    },
    generateTeamMonthOptions(val) {
      if (val != null) {
        this.team_filter_obj.selected_date = val;
      }
      if (this.team_filter_obj.selected_month_options != null) {
        this.team_filter_obj.selected_month_options = null;
      }
      this.team_filter_obj.month_options = this.getWeeksOfMonth(
        val.getFullYear(),
        val.getMonth() + 1
      );
      this.getFilteredUsers();
    },
    generateYourMonthOptions(val) {
      // console.log(val);
      if (this.popupObj.selected_month_week_options != null) {
        this.popupObj.selected_month_week_options = null;
      }
      this.popupObj.month_week_options = this.getWeeksOfMonth(
        val.getFullYear(),
        val.getMonth() + 1
      );
    },
    pageChanger(page) {
      if (page != this.current_page) {
        this.current_page = page;
        if (page == "your_summary") {
          this.your_filter_obj.selected_date = new Date();
          this.generateYourMonthOptions(this.your_filter_obj.selected_date);
          this.getYourSummaryReports();
        }
        if (page == "team_summary") {
          this.team_filter_obj.selected_date = new Date();
          this.team_filter_obj.selected_view_options =
            this.team_filter_obj.view_options[0];
          this.generateTeamMonthOptions(this.team_filter_obj.selected_date);
        }
      }
    },
    deleteSummaryReport(id) {
      Swal.fire({
        title: "Do you want to delete the summary ?",
        icon: "question",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonColor: "#32a852",
        cancelButtonColor: "#f00",
      }).then((res) => {
        if (res.value) {
          user
            .delete_summary_report(id)
            .then((res) => {
              if (res.status == 200) {
                Swal.fire({
                  title: "Summary Deleted Successfully",
                  icon: "success",
                });
                this.getYourSummaryReports();
              } else {
                Swal.fire({
                  title: "Failed To Delete Summary",
                  icon: "error",
                });
              }
            })
            .catch((err) => {
              console.error(err);
              Swal.fire({
                title: "Failed To Delete Summary",
                icon: "error",
              });
            });
        }
      });
    },
    getUserProjectCount(user) {
      // Count the number of projects from the comma-separated string
      if (!user.projects || user.projects.trim() === '') {
        return 0;
      }
      return user.projects.split(',').length;
    },
    redmineFilterHandler(filterData) {
      console.log("Redmine filter data received:", filterData);
      // Pass serverParams directly from redmine filter to API
      this.team_filter_obj.serverParams = Object.assign(
        {},
        this.team_filter_obj.serverParams,
        filterData
      );
      this.team_filter_obj.serverParams.page = 1;
      this.getTeamSummaryReports();
    },
    onResetServerParams() {
      this.team_filter_obj.serverParams = {
        filters: {},
        sort: [],
        page: 1,
        perpage: 100,
      };
      this.getTeamSummaryReports();
    },
    exportTeamSummary(format) {
      this.team_filter_obj.isLoading = true;
      
      // For PDF, generate on frontend; for Excel, use backend
      // PDF export is handled from frontend as when summary length is 5000, it is breaking if we do it from backend
      if (format === 'pdf') {
        // Fetch data without export flag for frontend PDF generation
        const dataParams = {
          ...this.team_filter_obj.serverParams,
          export: false,
          page: 1,
          perpage: 100000,
        };
        
        user.get_team_summary_reports(dataParams)
          .then((response) => {
            try {
              const jsPDF = require('jspdf').jsPDF;
              const autoTable = require('jspdf-autotable');
              
              const doc = new jsPDF();
              const pageWidth = doc.internal.pageSize.getWidth();
              const pageHeight = doc.internal.pageSize.getHeight();
              const currentDate = new Date();
              const dateStr = currentDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
              
              // Add title
              doc.setFontSize(16);
              doc.setTextColor(68, 114, 196);
              const title = `Team Summary Report - ${currentDate.toLocaleDateString('en-US', { month: '2-digit', year: '2-digit' }).replace('/', '-')}`;
              doc.text(title, pageWidth / 2, 15, { align: 'center' });
              
              // Prepare table data
              const tableData = response.data.data.data.map(row => [
                row.date_range_label || '',
                row.project_name || '',
                row.full_name || '',
                row.summary || ''
              ]);
              
              // Add table
              doc.autoTable({
                startY: 25,
                head: [['Date Range', 'Project', 'User', 'Summary']],
                body: tableData,
                headStyles: {
                  fillColor: [68, 114, 196],
                  textColor: [255, 255, 255],
                  fontStyle: 'bold',
                  halign: 'center',
                  valign: 'middle',
                  fontSize: 10,
                  cellPadding: 3
                },
                bodyStyles: {
                  fontSize: 9,
                  halign: 'left',
                  valign: 'top',
                  cellPadding: 3
                },
                alternateRowStyles: {
                  fillColor: [245, 245, 245]
                },
                columnStyles: {
                  0: { cellWidth: 25 },
                  1: { cellWidth: 20 },
                  2: { cellWidth: 25 },
                  3: { cellWidth: 100, overflow: 'linebreak' }
                },
                margin: { top: 10, right: 10, bottom: 10, left: 10 },
                didDrawPage: (data) => {
                  // Add footer
                  const pageSize = doc.internal.pageSize;
                  const pageHeight = pageSize.getHeight();
                  const pageWidth = pageSize.getWidth();
                  doc.setFontSize(9);
                  doc.setTextColor(128);
                  doc.text(
                    `Page ${data.pageCount}`,
                    pageWidth / 2,
                    pageHeight - 10,
                    { align: 'center' }
                  );
                }
              });
              
              // Download PDF
              doc.save(`team_summary_${currentDate.getFullYear()}_${String(currentDate.getMonth() + 1).padStart(2, '0')}.pdf`);
              this.team_filter_obj.isLoading = false;
            } catch (err) {
              console.error("PDF generation error:", err);
              alert("Failed to generate PDF");
              this.team_filter_obj.isLoading = false;
            }
          })
          .catch((error) => {
            console.error("Error fetching data for PDF:", error);
            alert("Failed to fetch data for PDF export");
            this.team_filter_obj.isLoading = false;
          });
      } else {
        // Excel export - use backend
        const exportParams = {
          ...this.team_filter_obj.serverParams,
          export: true,
          export_format: format,
          page: 1,
          perpage: 100000,
        };
        
        user.exportTeamSummary(exportParams)
          .then((response) => {
            const mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            const extension = 'xlsx';
            
            const blob = new Blob([response.data], { type: mimeType });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const currentDate = new Date();
            const dateStr = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}`;
            link.setAttribute('download', `team_summary_${dateStr}.${extension}`);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
            this.team_filter_obj.isLoading = false;
          })
          .catch((error) => {
            console.error("Export failed:", error);
            let errorMessage = "Failed to export team summary";
            if (error.response && error.response.data && error.response.data.detail) {
              errorMessage = error.response.data.detail;
            }
            alert(errorMessage);
            this.team_filter_obj.isLoading = false;
          });
      }
    },
  },
};
</script>

<style scoped>
.mandatory:after {
  content: "*";
  padding: 0px 2px;
  color: red;
}
::v-deep .vdp-datepicker__calendar-button .input-group-text {
  height: 100%;
  background-color: whitesmoke;
  border-top-right-radius: 0;
  border-right: 0px;
  border-bottom-right-radius: 0;
}
::v-deep .vdp-datepicker__clear-button .input-group-text {
  height: 100%;
  background-color: white;
  border-top-left-radius: 0;
  border-left: 0px;
  border-bottom-left-radius: 0;
  border-color: #f0f0f0;
}
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.5s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}
.not-filled-users-container {
  max-height: 400px;
  overflow-y: auto;
}
.not-filled-users-container::-webkit-scrollbar {
  width: 6px;
}
.not-filled-users-container::-webkit-scrollbar-track {
  background: rgba(255, 193, 7, 0.1);
  border-radius: 3px;
}
.not-filled-users-container::-webkit-scrollbar-thumb {
  background: rgba(255, 193, 7, 0.5);
  border-radius: 3px;
}
.not-filled-users-container::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 193, 7, 0.7);
}
</style>
